import { parseDate } from '@occc-app/lib/date';
import { TimeSeriesMetric } from '@occc/graphql';

export const getMetrics = (series: TimeSeriesMetric[]) => {
  return series.map(({ date, value }) => ({
    date: parseDate(date),
    value: { transactions: value },
  }));
};
